module.exports = __webpack_public_path__ + "media/images/mailer-mention-image-367188bb852ad52fa2c72cec1cb92f24.png";